<template>
  <section>
    <h4 class="section-title">
      {{ $t('History') }}
    </h4>
    <div class="report-info">
      <div class="report-filter-wrapper">
        <div class="report-filter-item">
          <div class="report-filter-item-title">{{ $t('Date') }}</div>
          <div class="report-filter-item-input-wrap">
            <date-picker
                v-model="dateRange"
                :disabled-date="disabledRange"
                :editable="false"
                :format="'DD/MM/YYYY'"
                :input-class="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'"
                :lang="$i18n.locale"
                :placeholder="$t('Date Range')"
                :popup-class="$vuetify.theme.dark ? 'theme-dark' : 'theme-light'"
                :range-separator="' - '"
                range
            ></date-picker>
          </div>
        </div>
        <div class="report-filter-item">
          <div class="report-filter-item-title">{{ $t('tradingAssets') }}</div>
          <div class="report-filter-item-input-wrap">
            <CustomSelect
                ref="selectSymbols"
                :options="symbolsOptionsList"
                custom-class="support-form"
                default="All"
                @update:modelValue="formData.symbol = $event"
            />
          </div>
        </div>
        <div class="report-filter-item">
          <div class="report-filter-item-title">{{ $t('Side') }}</div>
          <div class="report-filter-item-input-wrap">
            <CustomSelect
                ref="selectSide"
                :options="sideOptionsList"
                custom-class="support-form"
                default="All"
                @update:modelValue="formData.side = $event"
            />
          </div>
        </div>
        <div class="report-filter-button-wrap">
          <button @click="resetFilterParams">{{ $t('Set by default') }}</button>
        </div>
      </div>
    </div>
    <div class="report-content">
      <div class="preloader new-preloader" v-if="isLoading">
        <lottie-animation
            ref="preloader"
            :animationData="require('@/assets/img/Loader.json')"
            :loop="true"
            :autoPlay="true"
            :speed="1"
        />
      </div>
      <table v-if="history.value && history.value.size">
        <thead class="holder-table">
        <tr class="table-head">
          <th class="trading-pair-header" :data-label="$t('Trading Pair')">
            {{$t('Trading Pair')}}
          </th>
          <th :data-label="$t('Quantity')">
            {{ $t('Quantity') }}
          </th>
          <th :data-label="$t('Liquidation Price')">
            {{ $t('Liquidation Price') }}
          </th>
          <th :data-label="$t('Discount at Liqudation')">
            {{ $t('Discount at Liqudation') }}
          </th>
          <th :data-label="$t('Date')">
            {{ $t('Date') }}
          </th>
          <th :data-label="$t('Total Bids')">
            {{ $t('Total Bids') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <template>
          <tr v-for="(historyItem, index) in history.value" :key="index" class="table-body">
            <td :data-label="$t('Trading Pair')" class="coin-name">
              <img
                  :src="historyItem[1].image"
                  :alt="historyItem[1].symbol.split('_').join('/').toUpperCase()"
                  class="lot-history-image"
              >
              <span class="textMainColor">
            {{historyItem[1].symbol.split('_').join('/').toUpperCase()}}
          </span>
            </td>
            <td :data-label="$t('Quantity')">
            <span :class="true ? 'up' : 'down'">
              {{ historyItem[1].amount }}
            </span>
              {{historyItem[1].symbol.split('_')[0].toUpperCase()}}
            </td>
            <td :data-label="$t('Liquidation Price')">
            <span class="textMainColor">
              {{ prettifyToSix(toPrecisionNumber(historyItem[1].averageLiquidationPrice)) }}
            </span>
              {{historyItem[1].symbol.split('_')[1].toUpperCase()}}
            </td>
            <td :data-label="$t('Discount at Liqudation')">
            <span :class="historyItem[1].discount > 0 ? 'up' : historyItem[1].discount < 0 ? 'down' : ''">
              {{ historyItem[1].discount.toFixed(2) }}
            </span>
              %
            </td>
            <td :data-label="$t('Date')">
            <span class="textMainColor">
              {{ formatterDate(historyItem[1].updatedAt) }}
            </span>
              {{ formatterTime(historyItem[1].updatedAt) }}
            </td>
            <td :data-label="$t('Total Bids')">
            <span class="textMainColor">
              {{ historyItem[1].totalBids }}
            </span>
              {{ $t('bids') }}
            </td>
          </tr>
        </template>
<!--        <tr v-if="!isLoading && isDataEmpty">-->
<!--          <td colspan="8">-->
<!--            <div class="holder-not-logged-text">-->
<!--              <p class="secondary-text">{{$t('emptyPositionsText')}}</p>-->
<!--            </div>-->
<!--          </td>-->
<!--        </tr>-->
        </tbody>
      </table>
      <div v-if="!isLoading && isDataEmpty" class="holder-not-logged-text report-empty-wrap">
        <div class="report-empty-list">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.1351 5.89334C41.0418 4.8 39.1484 5.54667 39.1484 7.06667V16.3733C39.1484 20.2667 42.4551 23.4933 46.4818 23.4933C49.0151 23.52 52.5351 23.52 55.5484 23.52C57.0684 23.52 57.8684 21.7333 56.8018 20.6667C52.9618 16.8 46.0818 9.84 42.1351 5.89334Z" fill="#92939C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M46.9613 27.1733H54.668C56.1346 27.1733 57.3346 28.3733 57.3346 29.84V39.6441C55.2687 38.1884 52.7495 37.3333 50.0315 37.3333C43.0218 37.3333 37.3346 43.0205 37.3346 50.0302C37.3346 53.365 38.6218 56.4005 40.7262 58.6666H21.5213C13.308 58.6666 6.66797 53.3333 6.66797 43.8133V20.1866C6.66797 10.6666 13.308 5.33331 21.5213 5.33331H32.828C34.2946 5.33331 35.4946 6.53331 35.4946 7.99998V15.7066C35.4946 22.0266 40.6413 27.1733 46.9613 27.1733ZM57.3346 43.755V43.8133C57.3346 52.1992 52.1825 57.3365 45.3411 58.4415C42.3948 56.7941 40.4015 53.6436 40.4015 50.0302C40.4015 44.7143 44.7156 40.4002 50.0315 40.4002C52.9509 40.4002 55.5682 41.7013 57.3346 43.755ZM20.0013 47.3333H30.668C31.7613 47.3333 32.668 46.4266 32.668 45.3333C32.668 44.24 31.7613 43.3333 30.668 43.3333H20.0013C18.908 43.3333 18.0013 44.24 18.0013 45.3333C18.0013 46.4266 18.908 47.3333 20.0013 47.3333ZM20.0013 36.6666H36.0013C37.0946 36.6666 38.0013 35.76 38.0013 34.6666C38.0013 33.5733 37.0946 32.6666 36.0013 32.6666H20.0013C18.908 32.6666 18.0013 33.5733 18.0013 34.6666C18.0013 35.76 18.908 36.6666 20.0013 36.6666Z" fill="#92939C"/>
            <path d="M59.9855 57.2476L58.0636 55.3257C59.0655 53.8127 59.6584 51.993 59.6584 50.0302C59.6584 44.7143 55.3443 40.4002 50.0284 40.4002C44.7125 40.4002 40.3984 44.7143 40.3984 50.0302C40.3984 55.3461 44.7125 59.6602 50.0284 59.6602C51.9912 59.6602 53.7905 59.0672 55.3239 58.0654L57.2458 59.9873C57.6343 60.3758 58.125 60.5598 58.6361 60.5598C59.1473 60.5598 59.638 60.3758 60.0264 59.9873C60.742 59.2513 60.742 58.0245 59.9855 57.2476Z" fill="#92939C"/>
          </svg>
          <p class="secondary-text holder-not-logged-text">{{ $t('No records found') }}</p>
        </div>
      </div>
      <div class="table-footer">
        <b-pagination-nav

            v-if="!isLoading && history.value && history.value.size && count !== 1"
            v-model="paginationPage"
            :link-gen="linkGen"
            :number-of-pages="count"
            :per-page="pageSize"
            :total-rows="count"
            class="pagination"
            first-number
            last-number
            next-text="»"
            prev-text="«"
            use-router
        />
      </div>
    </div>
  </section>
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/hi';
import 'vue2-datepicker/locale/es';
import 'vue2-datepicker/locale/zh-cn';
import toPrecisionNumber from "../../mixins/toPrecisionNumber";
import moment from "moment";
import {useReactiveMap} from "vue-reactive-collection";

export default {
  name: "HistorySection",
  props: {
    isLoading: {
      type: Boolean
    },
    isDataEmpty: {
      type: Boolean
    },
    page: {},
    count: {},
    pageSize: {},
    history: {
      default: () => [],
    },
  },
  data() {
    return {
      sideOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'Buy',
          value: 'BUY',
        },
        {
          name: 'Sell',
          value: 'SELL',
        },
      ],
      symbolsOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'BTC/USDT',
          value: 'btc_usdt',
        },
        {
          name: 'ETH/USDT',
          value: 'eth_usdt',
        },
        {
          name: 'SOL/USDT',
          value: 'sol_usdt',
        },
        {
          name: 'ADA/USDT',
          value: 'ada_usdt',
        },
        {
          name: 'NEAR/USDT',
          value: 'near_usdt',
        },
        {
          name: 'APE/USDT',
          value: 'ape_usdt',
        },
        {
          name: 'ATOM/USDT',
          value: 'atom_usdt',
        },
        {
          name: 'AVAX/USDT',
          value: 'avax_usdt',
        },
        {
          name: 'DOT/USDT',
          value: 'dot_usdt',
        },
        {
          name: 'GMT/USDT',
          value: 'gmt_usdt',
        },
        {
          name: 'MATIC/USDT',
          value: 'matic_usdt',
        },
      ],
      dateRange: [new Date(new Date().getTime() - 604800000), new Date()],
      formData: {
        symbol: '',
        side: '',
      },
    }
  },
  mixins: [toPrecisionNumber],
  watch: {
    'dateRange'(value) {
      this.formData.dateFrom = isNaN(Date.parse(this.dateRange[0])) == false ? (String(Date.parse(this.dateRange[0])) / 1000) : '';
      this.formData.dateTo = isNaN(Date.parse(this.dateRange[1])) == false ? (String(Date.parse(this.dateRange[1]) + 86400000) / 1000) : '';
      this.changeSelectFilter();
    },
    'formData.symbol'() {
      this.changeSelectFilter();
    },
    'formData.side'() {
      this.changeSelectFilter();
    },
  },
  computed: {
    paginationPage() {
      return this.page
    }
  },
  methods: {
    linkGen(pageNum) {
      this.changeSelectFilter();
      return {
        path: '/liquidation-auction',
        query: { page: pageNum },
      };
    },
    disabledRange: function (date) {
      return date > new Date();
    },
    formatterDate: function (value) {
      return moment.utc(value).local().format('DD/MM/yy');
    },
    formatterTime: function (value) {
      return moment.utc(value).local().format('HH:mm');
    },

    prettifyToSix(num) {
      if(num === '-') {
        return '-'
      }
      const options = {
        style: 'currency',
        currency: 'USD',
        maximumSignificantDigits: num === 0 ? 6 : num < 1 ? 5 : 6,
        minimumSignificantDigits: num === 0 ? 6 : num < 1 ? 5 : 6,
      }
      num = Number(num).toLocaleString("en-US", options)
      return num.slice(1)
    },
    changeSelectFilter() {
      this.$emit('changeSelectFilter', this.formData)
    },
    resetFilterParams() {
      this.dateRange = [];
      this.formData.dateFrom = '';
      this.formData.dateTo = '';
      this.formData.symbol = '';
      this.formData.side = '';
      this.$emit('getData', this.formData)
      this.$emit('resetPagination', null)
      this.resetFilterToDefault();
    },
    resetFilterToDefault() {
      this.$refs.selectSide.reset();
      this.$refs.selectSymbols.reset();
    },
  },
  components: {
    LottieAnimation,
    DatePicker: () => import('vue2-datepicker'),
    CustomSelect: () => import('../inputs/CustomSelect'),
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  margin-top: 20px;
}

.coin-name {
  display: flex;
  align-items: center;

  svg {
    margin-right: 8px;
  }
}

tr {
  position: relative;
  z-index: 1;

  &:nth-child(even)::after {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    right: -20px;
    bottom: 0;
    left: -20px;
    background-color: var(--v-evenRowBackground-base);
  }
}

table tbody tr {
  border-width: 0;
}

td {
  padding: 8px 0;
}

th:last-child,
td:last-child {
  text-align: right;
}

.holder-not-logged-text {
  padding: 22px 0;
}

.lot-history-image {
  width: 19px;
  height: 19px;
  object-fit: cover;
  display: block;
  margin-right: 10px;
}

.v-application.theme--dark .textMainColor {
  color: #E9E9E9 !important;
}

.report-filter-button-wrap {
  margin-left: auto;
}

.report-filter-wrapper {
  margin-bottom: 20px;
}

.table-footer .pagination {
  margin-left: auto;
}

</style>
